import React, {Component} from 'react';
import {LoodingAssembly} from "./../components/comAssembly";
import {asyncComponent} from "./../config/asyncComponent";
const DetailContent=asyncComponent(()=>import(/* webpackChunkName: "IndexPage" */"./template1/content"));
export default class EsfDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			zujian : LoodingAssembly
		};
	}
	componentDidMount(){
		setTimeout(function(){
			this.setState({
				zujian : DetailContent
			})
		}.bind(this),5);
	}
    render(){
    	var Content = this.state.zujian?this.state.zujian:LoodingAssembly;
		return(
			<div>
		        <Content/>
	      	</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/esfHouseDetail/index.js